import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Style 
import * as S from './style';

export interface TagsProps {
    subjects?: (string | undefined)[];
    parent?: {
        title: string;
    };
    related_category?: string;
    theme?: string
}

const ArticleTagsCaseStudy: React.FC<TagsProps> = ({ subjects, parent, related_category, theme }) => {
    const category = related_category ? related_category : parent && parent.title.toLowerCase().replace(' ', '-');
    const tags = subjects ? subjects.filter(tag => tag !== undefined) : []
    const location = useLocation();
    const limitedTag = tags.slice(0, 5);


    return (
        <S.Tags>
            <div className="tags">
                {limitedTag.map((tag, i) => {
                    return (
                        <S.Link key={tag! + i} to={`/tag/${tag}`} className='tag'>
                         {tag}
                        </S.Link>
                    )
                })}
            </div>
        </S.Tags>
    )
}

export default ArticleTagsCaseStudy;